<template>
  <div class="log_page">
    <div class="log_page_top">
      <!-- 类别选择 -->
      <el-select size="mini" v-model.number="params.status" placeholder="请选择" style="width: 200px;">
        <el-option label="失败" :value="0"></el-option>
        <el-option label="成功" :value="1"></el-option>
      </el-select>
      <el-button size="mini" @click="getData">查询</el-button>
    </div>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column label="操作模块">
        <template slot-scope="scope">
          {{ scope.row.operationModule }}
        </template>
      </el-table-column>
      <el-table-column label="操作类型">
        <template slot-scope="scope">
          {{ scope.row.operationType }}
        </template>
      </el-table-column>
      <el-table-column label="操作描述">
        <template slot-scope="scope">
          {{ scope.row.operationDesc }}
        </template>
      </el-table-column>
      <!-- requestIp -->
      <el-table-column label="请求IP">
        <template slot-scope="scope">
          {{ scope.row.requestIp }}
        </template>
      </el-table-column>
      <!-- requestMethod -->
      <el-table-column label="请求方式">
        <template slot-scope="scope">
          {{ scope.row.requestMethod }}
        </template>
      </el-table-column>
      <!-- 按钮 -->
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="handleClick(scope.row)">查看详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="params.offset" :page-sizes="[10, 20, 30, 40]" :page-size="params.limit"
      layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    <!-- 详情弹出框 -->
    <el-dialog title="详情" :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
      <div class="descriptions">
        <div class="descriptions-title">日志信息</div>

        <table class="descriptions-table">
          <tbody>
            <tr>
              <th>操作模块</th>
              <td>{{ detailContent.operationModule }}</td>
              <th>操作类型</th>
              <td>{{ detailContent.operationType }}</td>
            </tr>
            <tr>
              <th>操作描述</th>
              <td colspan="3">{{ detailContent.operationDesc }}</td>
            </tr>
            <tr>
              <th>请求 IP</th>
              <td>{{ detailContent.requestIp }}</td>
              <th>请求方式</th>
              <td>{{ detailContent.requestMethod }}</td>
            </tr>
            <tr>
              <th>请求参数</th>
              <td colspan="3">{{ detailContent.requestParams }}</td>
            </tr>
            <tr>
              <th>创建时间</th>
              <td>{{ detailContent.createTime }}</td>
              <th>用户</th>
              <td>{{ detailContent.username }}</td>
            </tr>
            <tr>
              <th>执行时间</th>
              <td>{{ detailContent.executeTime }}</td>
              <th>状态</th>
              <td>
                {{ detailContent.status ? '成功' : '失败' }}
              </td>
            </tr>
            <tr>
              <th>方法名称</th>
              <td colspan="3">{{ detailContent.methodName }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import { getLogList } from "@/api/logManagement";
export default {
  name: "logManagement",
  data() {
    return {
      params: {
        user_id: "1",
        "offset": 1,
        "limit": 10,
        status: 1
      },
      tableData: [],
      dialogVisible: false,
      dialogLoading: false,
      detailContent: {},
      total: 0,
    };
  },
  methods: {
    async getData() {
      const res = await getLogList(this.params);
      this.tableData = res.data.data.list;
      this.total = res.data.data.total;
    },
    handleClick(row) {
      this.dialogVisible = true;
      this.detailContent = row;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    handleCurrentChange(val) {
      this.params.offset = val;
      this.getData();
    },
    handleSizeChange(val) {
      this.params.limit = val;
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
<style scoped>
.log_page_top {
  display: flex;
  gap: 10px;
}

.log_page {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.descriptions {
  background: #fff;
  padding: 16px;
  border-radius: 4px;
}

.descriptions-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 12px;
  color: #303133;
}

.descriptions-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.descriptions-table th,
.descriptions-table td {
  border: 1px solid #ebeef5;
  padding: 12px 10px;
  font-size: 14px;
  color: #606266;
  vertical-align: top;
  word-break: break-all;
}

.descriptions-table th {
  width: 140px;
  background: #fafafa;
  font-weight: 500;
  color: #303133;
  text-align: left;
}
</style>